import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'stx-chevron-line',
  templateUrl: './chevron-line.component.html',
  styleUrls: ['./chevron-line.component.scss'],
  imports: [MatIconButton, MatIcon, NgClass]
})
export class ChevronLineComponent {
  @Input() isExpanded: boolean;
  @Input() showChevron = true;
  @Output() toggleEvent = new EventEmitter<void>();
}
